import plugLeadLogo from '@assets/logo/partners/plug-lead.png';

export const PLATFORMS = {
    pluglead: {
        key: 'pluglead',
        name: 'PlugLead',
        logo: plugLeadLogo,
    },
    active_campaign: {
        key: 'active_campaign',
        name: 'ActiveCampaign',
        logo: null,
    },
    manual: {
        key: 'manual',
        name: 'Manual',
        logo: null,
    },
};

export const EVENTS = {
    'payments.confirmed': 'Pagamento confirmado',
    'payments.pix_generated': 'Pix gerado',
    'payments.checkout_dropped': 'Checkout abandonado',
};
